import { createFileRoute } from '@tanstack/react-router';
import { MarketShell, marketSearchSchema, requireMarketEnabled } from '../../../features/market';

export const Route = createFileRoute('/_auth/_feed/market')({
  beforeLoad: requireMarketEnabled,
  validateSearch: marketSearchSchema,
  component: MarketShell,
});
